import React, { useEffect, useRef } from 'react';
import type { CmsPageProviderCoreProps } from '@gov-nx/component/common';
import { CmsPageProviderCore } from '@gov-nx/component/common';
import { scrollIntoView } from '@gov-nx/web';
import { CmsPageSkeleton } from './CmsPageSkeleton';

export const CmsPageProvider = (props: CmsPageProviderCoreProps) => {
	const ref = useRef<{ init: () => void }>();
	useEffect(() => {
		if (ref.current) {
			ref.current.init();
			scrollIntoView({ behavior: 'instant' });
		}
	}, []);

	return (
		<CmsPageProviderCore
			ref={ref}
			{...props}
			skeleton={<CmsPageSkeleton>{props.skeleton}</CmsPageSkeleton>}>
			{props.children}
		</CmsPageProviderCore>
	);
};
